export default () => ({
  date: undefined,
  paymentForm: '',
  series: '',
  cfdis: [{ cfdi: null, amount: 0 }]
});
